import React from 'react';
import Proptypes from 'prop-types';
import { Grid, Row, Col } from 'react-bootstrap';
import { VIEW_DATASET_SUMMARY } from '../../../constants/saxs';
import DataCollectionListMenu from '../../../components/saxs/DataCollection/DataCollectionListMenu';

class SaxsDataCollectionListMenuContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            view: VIEW_DATASET_SUMMARY
        }
        this.setView = this.setView.bind(this);

    }

    render() {
        return (<Grid fluid>
            <Row> <Col xs={12}> <DataCollectionListMenu setView={this.setView} /> </Col> </Row>
            <Row>
                {this.props.children(this.state.view, this.setView)}
            </Row>
        </Grid>);
    }

    /** Change the view */
    setView(view) {
        this.setState({ view: view });
    }
}
export default SaxsDataCollectionListMenuContainer;


// WEBPACK FOOTER //
// ./src/containers/saxs/helpers/SaxsDataCollectionListMenuContainer.js